import React from "react";
import ChartChooserLogo from "../ChartChooserLogo/ChartChooserLogo";

type Props = {
    children?: React.ReactNode;
};

export default function ChartChooserAside({ children }: Props) {
    return (
        <aside className="flex flex-col items-center border-r-gray relative">
            <ChartChooserLogo />
            {children}
            <div className="help-link-container border-t border-gray-300">
                <button onClick={() => window.open("https://zebrabi.com/help-center/?product=office")} className="help-link">
                    Help
                </button>
            </div>
        </aside>
    );
}
